import { render, staticRenderFns } from "./PostFormGroupPhotosBV.vue?vue&type=template&id=5b7c7a31&"
import script from "./PostFormGroupPhotosBV.vue?vue&type=script&lang=js&"
export * from "./PostFormGroupPhotosBV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports